// eslint-disable-next-line import/prefer-default-export
export function isObjectEmpty(obj) {
  if (!obj) {
    return true;
  }

  return Object.values(obj).every((val) => typeof val === 'undefined');
}

export function isObjectEmptyByKey(obj) {
  // If the object is empty, returns true
  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }

  return true;
}
